export default class DtoTerritoryPollutants {
    constructor(obj) {
        this.code = obj.code
        this.name = obj.name
        this.nbActivities = obj.nbActivities
        this.nbInstitutions = obj.nbInstitutions
        this.headers = ['code', 'name', 'nbActivities', 'nbInstitutions']
    }
}